// Global variable for booking. This uses to expose public methods.
import {createHooks} from "@wordpress/hooks";

// This global param use to expose public methods.
window.wc_bookings = window.wc_bookings || {};
window.wc_bookings.hooks = createHooks();
